import { useState } from 'react';
import { Button, Card } from '../primitives';
import Modal from '../portals/Modal';
import Reauthenticate from '../popup/Reauthenticate';
import NewPassword from '../popup/NewPassword';
import { useTranslation } from '../../hooks/useTranslation';

export default function Security({ isReauthed, setIsReauthed }) {

    const [isOpen, setIsOpen] = useState(false);
    
    const t = useTranslation();

    return (
        <>
        <Card ctype="margin-bottom">
            <Card.Header>
                <h2>{t('Update Credentials')}</h2>
            </Card.Header>
            <Card.Body>
            <Button onClick={() => setIsOpen(true)} className="submit settings">
                {t('Update')}
            </Button>
            </Card.Body>
        </Card>
        <Modal open={isOpen} onClickOutside={() => setIsOpen(false)}>
            {isReauthed ? <NewPassword setIsOpen={setIsOpen} />
            : <Reauthenticate setIsReauthed={setIsReauthed} setIsOpen={setIsOpen} />}
        </Modal>
        </>
    )
}
